import { Component, OnInit, Input } from '@angular/core';
import { Validators, UntypedFormBuilder, ValidationErrors, ValidatorFn, UntypedFormGroup } from '@angular/forms';
import { AppConstants } from 'src/app/app.constants';
import { NgbActiveModal, NgbModalOptions, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from 'src/app/api.service';
import { FunctionsService } from 'src/app/services/functions.service';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { OkModalComponent } from 'src/app/generic-components/ok-modal/ok-modal.component';

@Component({
  selector: 'app-change-temp-password',
  templateUrl: './change-temp-password.component.html'
})

export class ChangeTempPasswordComponent implements OnInit {
  @Input() set userToUpdate(value: any) {
    this._userToUpdate = value;
  }
  constructor(
    private formBuilder: UntypedFormBuilder,
    public functionsService: FunctionsService,
    public activeModal: NgbActiveModal,
    private apiService: ApiService,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal,
    public translate:TranslateService) { }

  _userToUpdate: any;
  modalOptions: NgbModalOptions = {};
  formSubmitted: boolean = false;
  owner = false;

  private passwordMatchValidator: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    const password = control.get('password');
    const confirmPassword = control.get('confirmPassword');

    return password.value === confirmPassword.value ? null : { 'passwordsDontMatch': true };
  }

  changePasswordForm = this.formBuilder.group({
    password: ['', [Validators.required, Validators.minLength(8), Validators.pattern(AppConstants.passwordRegex)]],
    confirmPassword: ['', Validators.required]
  }, { validators: this.passwordMatchValidator });

  ngOnInit() {
    if(localStorage.getItem('isOwner')!=null && localStorage.getItem('isOwner')=="1"){
      this.owner = true;
    }
  }

  changeTempPassword(){
    this.spinner.show();
    document.getElementById("password_error").innerText = "";
    if (this.changePasswordForm.valid) {
      this.apiService
        .changeTempPassword(this._userToUpdate, this.changePasswordForm.value.password, this.changePasswordForm.value.confirmPassword)
        .subscribe(() => {
            this.activeModal.close();
            this.modalOptions.backdrop = 'static';
            this.modalOptions.keyboard = false;
            this.modalOptions.size = 'lg';
            const modalRef = this.modalService.open(OkModalComponent, this.modalOptions);
            modalRef.componentInstance.title = this.translate.instant('password.password_changed');
            modalRef.componentInstance.message = this.translate.instant('password.success_logout');
            this.translate.onLangChange.subscribe(() => {
              modalRef.componentInstance.title = this.translate.instant('password.password_changed');
              modalRef.componentInstance.message = this.translate.instant('password.success_logout');
            });
            modalRef.result.then(() => this.functionsService.userSignOut());
            this.spinner.hide();
          }, err => {
            document.getElementById("password_error").innerText = this.translate.instant(err["error"]["content"]);
            this.translate.onLangChange.subscribe(() => {
              document.getElementById("password_error").innerText = this.translate.instant(err["error"]["content"]);
            })
            this.spinner.hide()
          }
        );
    } else {
        this.formSubmitted = true;
        this.spinner.hide();
    }
  }

  get password() { return this.controlGetter('password'); }
  get confirmPassword() { return this.controlGetter('confirmPassword'); }

  controlGetter(controlName) {
    const control =  this.changePasswordForm.get(controlName);
    return control && (control.touched || this.formSubmitted) ? control : {};
  }
}
